import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SidebarRefreshService {
    private _menu = new Subject<void>();
    private _logo = new Subject<string>();

    readonly menu$ = this._menu.asObservable();
    readonly logo$ = this._logo.asObservable();

    refreshMenu(): void { this._menu.next(); }
    refreshLogo(url: string): void { this._logo.next(url); }
}
